// @flow
import * as React from 'react';

import type { Page$Context } from './types';

export default React.createContext<Page$Context>({});
export * from './types';
